"use client";

import Button from "@/components/ui/Button/Button";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "react-toastify";

export default function BuyCourse(props) {
    const router = useRouter();
    const [updating, setUpdating] = useState(false);

    const buyCourse = async () => {
        if (!updating) {
            if (!props.session) {
                toast.success(
                    "Avant de rejoindre cette formation il vous faut un compte Believemy.",
                );
                router.push(
                    `/signup?courseImage=${props.course.image}&courseSlug=${props.course.slug}`,
                );
                return;
            }

            setUpdating(true);

            let response = await fetch("/api/course/post/buy", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    slug: props.course.slug,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setUpdating(false);
                toast.error(data.message);
                if (data.already) {
                    router.push(`/course/${props.course.slug}/1/1?start=1`);
                } else {
                    router.push("/pricing");
                }
                return;
            } else {
                setUpdating(false);
                toast.success("Bienvenue sur votre formation Believemy");
                router.push(`/course/${props.course.slug}/1/1?start=1`);
                return;
            }
        }
    };
    return (
        <Button type="white" onClick={buyCourse} isLoading={updating} block>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-3 text-excitationOrange"
                viewBox="0 0 24 24"
            >
                <path
                    fill="currentColor"
                    d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.736 4 21.276 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648l12.812 6.968Z"
                ></path>
            </svg>
            Commencer
        </Button>
    );
}
